import {
  VENDOR_UPDATE_BOOKING,
  VENDOR_UPDATE_BOOKING_SUCCESS,
  VENDOR_UPDATE_BOOKING_ERROR,
  VENDOR_UPDATE_BOOKING_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const VendorUpdateBooking = (state = initialState, action) => {
  switch (action.type) {
    case VENDOR_UPDATE_BOOKING:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case VENDOR_UPDATE_BOOKING_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case VENDOR_UPDATE_BOOKING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case VENDOR_UPDATE_BOOKING_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default VendorUpdateBooking;
